import { render, staticRenderFns } from "./BoxAssignment.vue?vue&type=template&id=aeead4c2&"
import script from "./BoxAssignment.js?vue&type=script&lang=js&"
export * from "./BoxAssignment.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports